<template>
  <settings-modal
    :locked="isLoading"
    class="t-referrals-campaign-remove-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Are you sure you want to remove this campaign?</span>

    <error-alert
      :error="error"
    />

    <template slot="actions">
      <v-btn
        class="t-remove-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onRemoveButtonClick"
      >Remove</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal'
  import modal from '@/mixins/modal'
  import form from '@/mixins/form'
  import { mapActions, mapGetters } from 'vuex'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import flashMessages from '@/mixins/flashMessages'
  import ReferralCampaignsApi from '@/services/Api/ReferralCampaignsApi'

  export default {
    name: 'CampaignDeleteModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [modal, form, flashMessages],
    data () {
      return {
        error: undefined,
        isLoading: false,
        deleteCampaignApiRequest: new ApiRequest(ReferralCampaignsApi.deleteCampaign)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      campaign () {
        return this.modal.data.campaign
      },
      successCallback () {
        return this.modal.data.successCallback
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onRemoveButtonClick () {
        this.setError(null)
        this.setIsLoading(true)

        this.deleteCampaignApiRequest.execute(this.campaign.id)
          .then(() => {
            this.successCallback()
            this.showSuccessFlashMessage('Campaign successfully deleted!')
          })
          .catch((error) => this.setError(error))
          .finally(() => this.setIsLoading(false))
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
